// src/router.js
import { createRouter, createWebHistory } from 'vue-router';
import MapComponent from './components/MapComponent.vue';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: MapComponent
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

export default router;
